import { createReducer } from '@reduxjs/toolkit';
import { addBuilderStateCase } from '../../Global/ComponentState/ComponentStateReducer';
import MoonListActions from './MoonListActions';
import { MoonListState } from './MoonListState';

const initialState: MoonListState = {
  state: { current: 'loading' }
};
export const moonListReducer = createReducer<MoonListState>(initialState, (builder) => {
  addBuilderStateCase(builder, 'MOON_LIST');
  builder.addCase(MoonListActions.resetState, () => initialState);
  builder.addCase(MoonListActions.setMoonList, (state, action) => ({ ...state, moonList: action.payload }));
});
